const commonMsg = {
   en: {
      create: 'Create',
      new: 'New',
      no: 'No',
      invalidForm: `Please review your form and fulfill all requests.`,
      deleteConfirm: 'Are you sure?',
      search: 'search',
      delete: 'Delete',
      yes: 'Yes',
      dontDelete: 'Don´t delete',
      saved: 'saved',
      successDeleted: 'successfully deleted',
      newRecord: 'New',
      updateRecord: 'Update',
      back: 'Back',
      previous: 'Previous',
      next: 'Next',
      save: 'Save',
      addQuickAccess: 'Add to Quick Access menu',
      share: 'Share',
      restore: 'Restore',
      close: 'Close',
      myProfile: 'My Profile',
      changePin: 'Change Password',
      logout: 'Logout',
      notifications: 'Notifications',
      quickAccess: 'Quick Access',
      storeSelection: 'Store Selection',
      invalidCredentials: 'User and/or Password are invalid!',
      blockedUser: 'Your user is blocked! Please contact the Administrator.',
      filters: 'Filters',
      filter: 'Filter',
      saveError: 'Error trying to save. Contact support!',
      deleteError: 'Error trying to delete. Contact support!',
      allNotifications: 'All',
      groupHere: 'Drop columns here to group',
      gridNoData: 'Nothing found!',
      gridNoDataCrud: 'Add new by clicking on {0} button',
      availableColumns: 'Available Columns',
      loading: 'Loading...',
      pagerText: 'Page {0} of {1} ({2} records)',
      emptyChooserPanel: 'Hide columns by dropping them here',
      selectMany: 'Select Many',
      nothingChanged: 'Nothing has changed!',
      mustChooseCompany: 'Please choose a Company!',
      block: 'Block',
      print: 'Print',
      invalidMethodCall: 'Invalid server method call!'
   },
   pt: {
      create: 'Cadastrar',
      new: 'Novo',
      no: 'Não',
      invalidForm: `Revise o formulário e preencha o que faltou.`,
      deleteConfirm: 'Você tem certeza?',
      search: 'buscar',
      delete: 'Excluir',
      yes: 'Sim',
      dontDelete: 'Não excluir',
      saved: 'gravado',
      successDeleted: 'excluído com sucesso',
      newRecord: 'Incluir',
      updateRecord: 'Alterar',
      back: 'Voltar',
      previous: 'Anterior',
      next: 'Próximo',
      save: 'Salvar',
      addQuickAccess: 'Adicionar no Acesso Rápido',
      share: 'Compartilhar',
      restore: 'Restaurar',
      close: 'Fechar',
      myProfile: 'Meu Perfil',
      changePin: 'Alterar Senha',
      logout: 'Sair',
      notifications: 'Notificações',
      quickAccess: 'Acesso Rápido',
      storeSelection: 'Escolha a Empresa',
      invalidCredentials: 'Usuário e/ou senha inválidos!',
      blockedUser: 'Seu usuário está bloqueado. Fale com o Administrador.',
      filters: 'Filtros',
      filter: 'Filtrar',
      saveError: 'Não foi possível Salvar. Favor avisar ao suporte.',
      deleteError: 'Não foi possível Excluir. Favor avisar ao suporte.',
      allNotifications: 'Todas',
      groupHere: 'Agrupe dados arrastando a coluna para cá',
      gridNoData: 'Nada encontrado!',
      gridNoDataCrud: 'Para adicionar clique no botão {0}',
      availableColumns: 'Colunas Disponíveis',
      loading: 'Carregando...',
      pagerText: 'Pág {0} de {1} ({2} registros)',
      emptyChooserPanel: 'Oculte colunas arrastando-as para cá.',
      selectMany: 'Selecionar Vários',
      nothingChanged: 'Nada foi alterado!',
      mustChooseCompany: 'Faltou escolher a Empresa!',
      block: 'Bloquear',
      print: 'Imprimir',
      invalidMethodCall: 'Chamada de método inválida!'
   }
};


export default commonMsg;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@consigmais-team/vue-common/locale/index.js
// module id = RYdS
// module chunks = 0